import { render, staticRenderFns } from "./UploadNewForm.vue?vue&type=template&id=dd12f786&scoped=true"
import script from "./UploadNewForm.vue?vue&type=script&lang=js"
export * from "./UploadNewForm.vue?vue&type=script&lang=js"
import style0 from "./UploadNewForm.vue?vue&type=style&index=0&id=dd12f786&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd12f786",
  null
  
)

export default component.exports